import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

import { IMenuItem } from 'src/components'

const useMenuItems = (items: IMenuItem[]) => {
  const [searchParams, setSearchParams] = useSearchParams()
  const [menuItems, setMenuItems] = useState<IMenuItem[]>(items)

  useEffect(() => {
    const curTab = searchParams.get('tab')
    curTab
      ? setMenuItems((prev: IMenuItem[]) =>
          prev.map((item) => ({
            ...item,
            isActive: item.tab === curTab,
          })),
        )
      : setMenuItems((prev) =>
          prev.map((item, index) =>
            !index ? { ...item, isActive: true } : { ...item, isActive: false },
          ),
        )
  }, [searchParams, setSearchParams])

  const handleChooseMenuItem = (currentItem: IMenuItem) => {
    const item = menuItems.find((item) => item.tab === currentItem.tab)
    if (item && item.isActive) return

    currentItem.tab ? setSearchParams({ tab: currentItem.tab }) : setSearchParams({})
  }

  return { menuItems, setMenuItems, handleChooseMenuItem }
}

export { useMenuItems }
